import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { MenuItem, Select, TableCell, TableContainer } from "@mui/material";

// material-ui icons
import { Loop } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import jamezzTableStyle from "../../components/JamezzTable/JamezzTableStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import CustomInput from "../../components/CustomInput/CustomInput";
import SweetAlert from "react-bootstrap-sweetalert";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import * as actions from "../../store/actions";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Index extends React.Component {
  state = {
    applyTranslationsAlert: false,
    scanTranslationsAlert: false,
    applyingTranslations: false,
    scanningTranslations: false,

    languageCodes: [],
  };

  jamezzTable = React.createRef();

  /**
   * Component life cycle functies
   */
  componentDidMount() {
    this.loadExtraData();
  }

  loadExtraData = () => {
    axios
      .get("core/backofficeTranslations/languageCodes")
      .then((response) => {
        const languageCodes = response.data.data.map((languageCode) => {
          return (
            <MenuItem key={languageCode.toUpperCase()} value={languageCode}>
              {languageCode.toUpperCase()}
            </MenuItem>
          );
        });

        this.setState({
          languageCodes: languageCodes,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  alertApplyTranslations = (e) => {
    this.setState({
      applyTranslationsAlert: true,
    });
  };

  alertScanTranslations = (e) => {
    this.setState({ scanTranslationsAlert: true });
  };

  cancelApplyTranslations = () => {
    this.setState({ applyTranslationsAlert: false });
  };

  cancelScanTranslations = () => {
    this.setState({ scanTranslationsAlert: false });
  };

  confirmApplyTranslations = () => {
    this.setState({
      applyingTranslations: true,
    });

    axios
      .get("core/backofficeTranslations/applyTranslations")
      .catch((err) => {
        toast.warn(
          <TranslationWrapper tDefault={"Cannot load or sync this POS API"} tKey={"Cannot load or sync this POS API"} />
        );
      })
      .finally(() => {
        this.setState({
          applyingTranslations: false,
        });
      });

    this.cancelApplyTranslations();
  };

  confirmScanTranslations = () => {
    this.setState({
      scanningTranslations: true,
    });

    axios
      .get("core/backofficeTranslations/scanForTranslations")
      .catch((err) => {
        toast.warn(
          <TranslationWrapper tDefault={"Cannot load or sync this POS API"} tKey={"Cannot load or sync this POS API"} />
        );
      })
      .finally(() => {
        this.setState({
          scanningTranslations: false,
        });
      });

    this.cancelScanTranslations();
  };

  handleOnUpdateSuccess = (row, data) => {
    try {
      if (!Object.keys(data)[0].endsWith("value") || row === null) {
        return;
      }

      const translations = JSON.parse(localStorage.getItem("new_backoffice_translations"));
      const language = Object.keys(data)[0].match(/contents.([a-z]{2})/i)[1];
      let updatedTranslations = {};

      const newTranslation = { [row[2]]: row[4] };

      if (translations !== null) {
        updatedTranslations[language] = { ...translations[language], ...newTranslation };
      } else {
        updatedTranslations[language] = newTranslation;
      }

      localStorage.setItem("new_backoffice_translations", JSON.stringify(updatedTranslations));
    } catch (e) {
      console.error(e);
    }
    this.jamezzTable.current?.refreshData();
  };

  renderCollapse = (rowData) => {
    return (
      <TableContainer style={{ paddingLeft: "20px" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <strong>
                  <TranslationWrapper tDefault={"English value"} tKey={"backoffice_translations.en_value"} />
                </strong>
              </TableCell>
              <TableCell>{rowData[0]["contents"][Object.keys(rowData[0]["contents"])[0]]["value_en"] ?? "-"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>
                  <TranslationWrapper tDefault={"AI Translated"} tKey={"backoffice_translations.ai_value"} />
                </strong>
              </TableCell>
              <TableCell>
                {rowData[0]["contents"][Object.keys(rowData[0]["contents"])[0]]["ai_translator_value"] ?? "-"}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>
                  <TranslationWrapper tDefault={"Default"} tKey={"backoffice_translations.default"} />
                </strong>
              </TableCell>
              <TableCell>
                {(rowData[0]["translation_default"] ?? "").length ? rowData[0]["translation_default"] : "-"}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>
                  <TranslationWrapper tDefault={"Path"} tKey={"backoffice_translations.path"} />
                </strong>
              </TableCell>
              <TableCell>
                {(rowData[0]["translation_file_path"] ?? "").length ? rowData[0]["translation_file_path"] : "-"}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>
                  <TranslationWrapper tDefault={"Last edited by"} tKey={"backoffice_translations.last_edit_by"} />
                </strong>
              </TableCell>
              <TableCell>
                {rowData[0]["contents"][Object.keys(rowData[0]["contents"])[0]]["username"] ?? "Jamezz"} (
                {format(
                  new Date(rowData[0]["contents"][Object.keys(rowData[0]["contents"])[0]]["updated_at"]),
                  "dd-MM-yyyy HH:mm"
                )}
                )
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  getLanguageCode = () => {
    return this.props.filters["translations:contents"]?.filters?.language_code?.value ?? "en";
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.scanTranslationsAlert ? (
          <SweetAlert
            cancelBtnCssClass={classes.button + " " + classes.danger}
            cancelBtnText={getTranslation("global.button.annuleren", "Annuleren")}
            confirmBtnCssClass={classes.button + " " + classes.success}
            confirmBtnText={getTranslation("global.buttons.ok", "Ok")}
            onCancel={this.cancelScanTranslations}
            onConfirm={this.confirmScanTranslations}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={getTranslation("backoffice_translations.scan.confirm", "Scan for new translations?")}
            warning
          />
        ) : (
          ""
        )}

        {this.state.applyTranslationsAlert ? (
          <SweetAlert
            cancelBtnCssClass={classes.button + " " + classes.danger}
            cancelBtnText={getTranslation("global.button.annuleren", "Annuleren")}
            confirmBtnCssClass={classes.button + " " + classes.success}
            confirmBtnText={getTranslation("global.buttons.ok", "Ok")}
            onCancel={this.cancelApplyTranslations}
            onConfirm={this.confirmApplyTranslations}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={getTranslation("backoffice_translations.apply.confirm", "Generate new translation file?")}
            warning
          />
        ) : (
          ""
        )}

        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Translations"} tKey={"backoffice_translations.pagetitle"} />}
        />

        <GridContainer
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <GridItem>
            <Button
              color={"info"}
              disabled={this.state.applyingTranslations || this.state.scanningTranslations}
              onClick={this.alertScanTranslations}
            >
              {this.state.scanningTranslations ? (
                <span>
                  <Loop
                    style={{
                      animation: "spin 2s linear infinite reverse",
                      marginRight: "7px",
                    }}
                  />
                  <style>{`
                      @keyframes spin {
                           0% { transform: rotate(0deg); }
                           100% { transform: rotate(360deg); }
                      }
                  `}</style>
                </span>
              ) : null}

              <TranslationWrapper tDefault={"Scan Translations"} tKey={"backoffice_translations.scan"} />
            </Button>

            <Button
              color={"success"}
              disabled={this.state.applyingTranslations || this.state.scanningTranslations}
              onClick={this.alertApplyTranslations}
            >
              {this.state.applyingTranslations ? (
                <span>
                  <Loop
                    style={{
                      animation: "spin 2s linear infinite reverse",
                      marginRight: "7px",
                    }}
                  />
                  <style>{`
                    @keyframes spin {
                         0% { transform: rotate(0deg); }
                         100% { transform: rotate(360deg); }
                    }
                `}</style>
                </span>
              ) : null}

              <TranslationWrapper tDefault={"Apply translations"} tKey={"backoffice_translations.apply"} />
            </Button>
          </GridItem>
          <GridItem>
            <Select
              onChange={(e) => {
                let newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                newFilters.language_code = {
                  field: "language_code",
                  operator: "=",
                  value: e.target.value,
                };
                this.props.setFilter("translations:contents", {
                  relation: "contents",
                  filters: newFilters,
                });
              }}
              value={this.getLanguageCode()}
            >
              {this.state.languageCodes}
            </Select>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem sm={3} xs={12}>
            <Select
              onChange={(e) => {
                let newFilters;
                switch (e.target.value) {
                  case 1:
                    newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                    delete newFilters.locked;
                    this.props.setFilter("translations:contents", {
                      relation: "contents",
                      filters: newFilters,
                    });
                    break;
                  case 2:
                    newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                    newFilters.locked = {
                      field: "locked",
                      operator: "=",
                      value: 1,
                      selectValue: 2,
                    };
                    this.props.setFilter("translations:contents", {
                      relation: "contents",
                      filters: newFilters,
                    });
                    break;
                  case 3:
                    newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                    newFilters.locked = {
                      field: "locked",
                      operator: "=",
                      value: 0,
                      selectValue: 3,
                    };
                    this.props.setFilter("translations:contents", {
                      relation: "contents",
                      filters: newFilters,
                    });
                    break;
                }
              }}
              style={{
                width: "100%",
              }}
              value={this.props.filters["translations:contents"]?.filters?.locked?.selectValue ?? 1}
            >
              <MenuItem key={1} value={1}>
                All
              </MenuItem>
              <MenuItem key={2} value={2}>
                Checked
              </MenuItem>
              <MenuItem key={3} value={3}>
                Unchecked
              </MenuItem>
            </Select>
          </GridItem>

          <GridItem sm={3} xs={12}>
            <CustomInput
              formControlProps={{
                style: { paddingTop: "0" },
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                placeholder: getTranslation("backoffice_translations.filters.key", "Filter op key"),
                value: this.props.filters["translations:translation_key"]?.value ?? "",
                onChange: (e) => {
                  if (e.target.value) {
                    this.props.setFilter("translations:translation_key", {
                      field: "translation_key",
                      operator: "like",
                      value: e.target.value,
                    });
                  } else {
                    this.props.setFilter("translations:translation_key", null);
                  }
                },
              }}
            />
          </GridItem>

          <GridItem sm={3} xs={12}>
            <CustomInput
              formControlProps={{
                style: { paddingTop: "0" },
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                placeholder: getTranslation("backoffice_translations.filters.value", "Filter op vertaling"),
                value: this.props.filters["translations:contents"]?.filters?.value?.value ?? "",
                onChange: (e) => {
                  if (e.target.value) {
                    let newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                    newFilters.value = {
                      field: "value",
                      operator: "like",
                      value: e.target.value,
                    };
                    this.props.setFilter("translations:contents", {
                      relation: "contents",
                      filters: newFilters,
                    });
                  } else {
                    let newFilters = { ...this.props.filters["translations:contents"]?.filters } ?? {};
                    delete newFilters.value;
                    this.props.setFilter("translations:contents", {
                      relation: "contents",
                      filters: newFilters,
                    });
                  }
                },
              }}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                {
                  dbfield: "contents." + this.getLanguageCode() + ".locked",
                  editable: true,
                  inputtype: "Switch",
                },
                { dbfield: "translation_key", editable: false },
                { dbfield: "contents." + this.getLanguageCode() + ".current" },
                {
                  dbfield: "contents." + this.getLanguageCode() + ".value",
                  editable: true,
                  inputtype: "Input",
                },
                {
                  dbfield: "contents." + this.getLanguageCode() + ".applied",
                  editable: true,
                  inputtype: "Checkbox",
                  disabled: true,
                },
              ]}
              fetchUrl={"core/backofficeTranslations?language_code=" + this.getLanguageCode()}
              filters={this.props.filters}
              headerIcon={<LinkIcon />}
              headers={[
                {
                  label: getTranslation("backoffice_translations.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("backoffice_translations.table.checked", "Checked"),
                  sortable: false,
                },
                {
                  label: getTranslation("backoffice_translations.table.key", "Key"),
                  sortable: true,
                  sortKey: "translation_key",
                },
                {
                  label: getTranslation("backoffice_translations.table.source", "Current"),
                  sortable: false,
                },
                {
                  label: getTranslation("backoffice_translations.table.target", "To"),
                  sortable: false,
                },
                {
                  label: getTranslation("Live"),
                  sortable: false,
                },
              ]}
              onUpdateSuccess={this.handleOnUpdateSuccess}
              reduxKey={"backofficeTranslations"}
              ref={this.jamezzTable}
              renderCollapse={this.renderCollapse}
              tableTitle={<TranslationWrapper tDefault={"Translations"} tKey={"backoffice_translations.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["translations:translation_key"]) {
    filters["translations:translation_key"] = state.filtersV2["translations:translation_key"];
  }
  if (state.filtersV2["translations:contents"]) {
    filters["translations:contents"] = state.filtersV2["translations:contents"];
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, jamezzTableStyle));
